import { graphql } from 'react-apollo';
import { UPDATE_PROFILE } from '../../mutation';

export const updateProfile = graphql(UPDATE_PROFILE, { name: 'updateProfile' });
